import { Component, NgZone, OnInit, ViewChild } from '@angular/core';
import SwiperCore, { Autoplay } from 'swiper/core';
import { FormControl, FormGroup, NgForm, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import * as cfg from 'src/config.json';
import { MatDialog } from '@angular/material/dialog';
import { PrivacyPolicyComponent } from '../privacy-policy/privacy-policy.component';
import { AuthService } from 'src/app/auth/auth.service';
import { environment } from 'src/environments/environment';
import { LogService } from 'src/app/services/log.service';
SwiperCore.use([Autoplay]);
@Component({
  selector: 'app-start',
  templateUrl: './start.component.html',
  styleUrls: ['./start.component.scss']
})
export class StartComponent implements OnInit {
  public debug = environment.debug;

  sending = false;
  token = null;
  private config = cfg.default.client
  displayPPerror = false;
  displayMsg = false;
  displayErrMsg = false;

  contactForm2 = new FormGroup({
    name: new FormControl('', [
      Validators.required,
      Validators.minLength(5)
    ]),
    tel: new FormControl('', [
      Validators.pattern('[+]?[0-9 ]{6,15}'),
      Validators.maxLength(15)
    ]),
    email: new FormControl('', [
      Validators.required,
      Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/) // https://emailregex.com/
    ]),
    content: new FormControl('', [
      Validators.required,
      Validators.maxLength(500)
    ]),
    policy: new FormControl('')
  });

  get name() { return this.contactForm2.get('name') }
  get tel() { return this.contactForm2.get('tel') }
  get email() { return this.contactForm2.get('email') }
  get content() { return this.contactForm2.get('content') }

  getErrorMessage(fieldName) {
    if (this.contactForm2.get(fieldName).hasError('required')) { return 'Pole wymagane' }
    if (this.contactForm2.get(fieldName).hasError('pattern')) { return 'Wprowadzone dane są niepoprawne' }
    return 'Wprowadzone dane są niepoprawne'
  }



  tabs = [
    {
      icon: "qr_code",
      title: "Klient skanuje kod QR znajdujący się na stoliku",
      subtitle: "i zostaje przekierowany na stronę www z aktualnym menu",
      image: "smart1.png"
    },
    {
      icon: "touch_app",
      title: "Wybiera na co ma ochotę",
      subtitle: "Ewentualnie dodaje komentarz do zamówienia",
      image: "smart2.png"
    },
    {
      icon: "shopping_cart",
      title: "Zamawia / Płaci",
      subtitle: "i czeka na potwierdzenie przyjęcia zamówienia",
      image: "smart3.png"
    },
    {
      icon: "fact_check",
      title: "Restauracja akceptuje zamówienie",
      subtitle: "i informuje o tym fakcie klienta",
      image: "smart4.png"
    },
    {
      icon: "restaurant_menu",
      title: "Zamówienie gotowe",
      subtitle: "",
      image: "smart5.png"
    },

  ]
  constructor(
    private zone: NgZone,
    private http: HttpClient,
    public dialog: MatDialog,
    private log: LogService
    // private auth: AuthService //JUST FOR DEBUG
  ) { }

  ngOnInit(): void {
  }

  openPPDialog(){
    const ppDialogRef = this.dialog.open(PrivacyPolicyComponent);
  }

  getToken(e) {
    this.zone.run(() => { this.token = e; });
  }

  submitDisabled(): boolean {
    if (!this.token) { return true; };
    if (this.contactForm2.invalid) { return true; };
    return false;
  }

  async sendMessage() {
    if(!this.contactForm2.get('policy').value) {
      return this.displayPPerror = true;
    };
    this.sending = true;
    this.displayPPerror = false;
    try {
      const resp = await this.http.post(this.config.sendMessageFromContactForm, { token: this.token, data: this.contactForm2.value }).toPromise();
      this.log.log(resp);    
      this.displayMsg = true;  
      // alert('Wiadomość została wysałana.');
      this.contactForm2.reset({
        name:'',
        tel:'',
        email:'',
        content:''
      });
    } catch (error) {
      this.displayErrMsg = true;
      // alert('Wystąpił błąd podczas wysyłania wiadomości.');
    }
    this.sending = false;
  }

  // async debug() {
  //   this.log.log(await this.auth.checkIfProperBrowser());
  // }
}
